"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CheckedCircleIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "45",
  height: "44",
  viewBox: "0 0 45 44",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
        fill: "#4DAA50",
        className: "svg-fill-primary",
        cx: 22.5,
        cy: 22,
        rx: 22.5,
        ry: 22
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        stroke: "#FFF",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.842 23.935l7.053 6.17 16.631-16.21",
        className: "svg-stroke-secondary"
      })]
    })
  })]
});

CheckedCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(CheckedCircleIcon);

exports.default = _default;